import { useEffect, useState } from 'react'
import { HeaderImport } from './Imports'
import "../../i18n/i18n"
const { RoutesMap, LuLanguages, LuKeyRound, LuPower, LuUserCircle, LuUserCog, useNavigate, Dropdown, Logo, moment, SessionManager, useTranslation } = HeaderImport

export default function Header(props) {

    const { collapsed, setCollapsed } = props

    const [date, setDate] = useState(new Date().toDateString())
    const [time, setTime] = useState(moment().format("HH:mm:ss"))
    const navigate = useNavigate()
    const { t, i18n } = useTranslation()

    let cookieUser = SessionManager.getCookie("user");
    let user_data = cookieUser ? JSON.parse(cookieUser) : null;

    const logout = () => {
        SessionManager.removeCookie("user_token");
        SessionManager.removeCookie("user");
        SessionManager.clearSession();
        navigate(RoutesMap.LOGIN.path)
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(moment().format("HH:mm:ss"));
        }, 1000);

        return () => clearInterval(interval);
    }, [])

    return (
        <>
            <nav className="navbar navbar_body fixed-top" >
                <div className="container-fluid">
                    <div className="navbar-brand navbar-logo">
                        <img src={Logo} className='img-fluid login_bg_max' alt="logo" />
                    </div>

                    <div className='d-flex align-items-center'>
                        <span className='text-light fw-medium' style={{ fontSize: '13px' }}>🕒 {time}</span>
                        <span className='text-secondary ms-1 me-1'>|</span>
                        <span style={{ fontSize: '13px' }} className='text-light fw-medium'>{date}</span>
                        <span className='text-secondary ms-1 me-1'>|</span>
                        <LuLanguages size={20} style={{ cursor: 'pointer' }} className='text-light'
                            onClick={() => {
                                const newLang = i18n.language === 'en' ? 'ar' : 'en';
                                i18n.changeLanguage(newLang);
                                document.documentElement.setAttribute('dir', newLang === 'ar' ? 'rtl' : 'ltr');
                                SessionManager.setSession('lang_key', newLang);
                            }}
                        />
                        <span className='text-secondary ms-1 me-1'>|</span>
                        <span className='text-danger fw-medium' style={{ fontSize: '13px' }}>Techlene Associate</span>

                        <Dropdown>
                            <Dropdown.Toggle
                                variant=""
                                size='sm'
                                style={{ color: 'white' }}
                            >
                                <LuUserCog size={16} className={i18n.language === 'ar' ? 'mb-1 ms-1' : 'mb-1 me-1'} />{`${user_data?.firstName} ${user_data?.lastName}`}!
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ fontSize: '13px' }}>
                                <Dropdown.Item href=""><LuUserCircle size={16} className='mb-1 me-1' /> Profile</Dropdown.Item>
                                <Dropdown.Item href=""><LuKeyRound size={16} className='mb-1 me-1' /> Change Password</Dropdown.Item>
                                <hr className='hr_line' />
                                <Dropdown.Item href="" onClick={() => logout()}><LuPower size={16} className='me-1' /> Log Out</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </nav>
        </>
    )
}